import React from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { toString } from 'lodash-es';

import {
  Menu,
  MenuItem,
  MenuButton,
  useMenuProps,
} from '../../../components/DropdownSet';
import Tooltip from '../../../components/Tooltip';

const defaultOptions = [
  { value: '10', label: '10' },
  { value: '25', label: '25' },
  { value: '50', label: '50' },
];

const TablePerPageDropdown = ({
  active,
  total,
  disabled,
  options = defaultOptions,
  onChange,
}) => {
  const menuProps = useMenuProps({
    align: 'end',
    menuStyle: { width: 100 },
  });

  const handleChange = ({ value }) => {
    onChange(value);
  };

  const normalizedOptions = total ?
    options.map((option, index) => ({ ...option, disabledOption: index > 0 && total <= parseInt(options[index - 1].value, 10) })) :
    options;

  return (
    <Tooltip wrapChildrenInHtmlNode content={disabled ? 'You do not currently have any exports' : ''} >
      <Menu
        menuButton={(
          <MenuButton
            variant="light"
            shape="square"
            caret={false}
            disabled={disabled}
          >
            <span className="hicon-settings-alt" />
          </MenuButton>
      )}
        {...menuProps}
      >
        {normalizedOptions.map(({ label, value, disabledOption }) => {
        const isActive = !disabledOption && toString(active) === toString(value);

        return (
          <Tooltip content={disabledOption ? `You have only ${total} exports` : ''} >
            <MenuItem
              key={value}
              value={value}
              disabled={disabledOption}
              className={cx({ active: isActive })}
              onClick={itemValue => !isActive && handleChange(itemValue)}
            >
              {label}
            </MenuItem>
          </Tooltip>
        );
      })}
      </Menu>
    </Tooltip>
  );
};

TablePerPageDropdown.propTypes = {
  active: T.oneOfType([T.string, T.number]),
  total: T.number,
  disabled: T.bool,
  options: T.arrayOf(
    T.shape({
      value: T.string,
      label: T.node,
    }),
  ),
  onChange: T.func.isRequired,
};

export default TablePerPageDropdown;
